import React from 'react';
import { Alert } from '@mui/material';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    const { error } = this.state;
    if (error) {
      const errorText = error?.stack || error?.message || 'Unexpected error';
      return (
        <Alert severity="error">
          <pre style={{ margin: 0, whiteSpace: 'pre-wrap' }}>{errorText}</pre>
        </Alert>
      );
    }
    const { children } = this.props;
    return children;
  }
}

export default ErrorBoundary;
